import { combineReducers } from 'redux'
import navigation from '../components/navigation/reducer'
import contactUs from '../components/contactUs/reducer'

export default combineReducers({navigation, contactUs})
